import { useQuery, UseQueryOptions } from 'react-query';

import { getIsLoggedIn } from '../graphql/login.2';

export function useIsLoggedInQuery(options?: UseQueryOptions<boolean, unknown, boolean, ['is_logged_in']>) {
  return useQuery({
    queryKey: ['is_logged_in'],
    queryFn: async () => {
      const { data } = await getIsLoggedIn();
      return data.is_logged_in;
    },
    ...options,
  });
}
